import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router'
import { ConnectedRouter } from 'react-router-redux'
import withRoot from './withRoot'

import MainContainer from './main/MainContainer'
import SigninContainer from './signin/SigninContainer'
import AppBarContainer from './main/AppBarContainer'
import LoadingContainer from './main/LoadingContainer'
import ProfileContainer from './profile/ProfileContainer'
import {UserIsAuthenticated, UserIsNotAuthenticated} from './route'
import TestContainer from './test/TestContainer';
import TermsOfServiceComponent from './main/TermsOfServiceComponent';
import PrivacyComponent from './main/PrivacyComponent';
import SearchContainer from './search/SearchContainer';

class App extends Component {
  render() {
    const { history } = this.props
    return (
      <div>
        <AppBarContainer/>
        <ConnectedRouter history={history}>
          <Switch>
            <Route exact path='/signin' component={UserIsNotAuthenticated(SigninContainer)} />
            <Route exact path='/' component={UserIsAuthenticated(MainContainer)} />
            <Route exact path='/profile' component={UserIsAuthenticated(ProfileContainer)} />
            <Route exact path='/test' component={UserIsAuthenticated(TestContainer)}/>
            <Route exact path='/search' component={UserIsAuthenticated(SearchContainer)}/>
            <Route exact path='/termsOfService' component={TermsOfServiceComponent}/>
            <Route exact path='/privacy' component={PrivacyComponent}/>

            <Redirect to='/'/>
          </Switch>
        </ConnectedRouter>
        <LoadingContainer/> 
      </div>
    )
  }
}

export default withRoot(App)



// WEBPACK FOOTER //
// ./src/App.js